import gql from 'graphql-tag'

export const CREATE_USER_FIRED = gql`
    mutation CreateUserFired($kind: Kind!, $text: String!) {
        createUserFired(kind: $kind, text: $text)
    }
`